export default {"src":"/_next/static/media/APTV.a4d2747b.svg","height":18,"width":18};